module.exports = "data:application/vnd.ms-fontobject;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJhOTkwZjYxMWYyMzA1ZGMxMjk2NWYxODZjMmVmMjY5MC5lb3QiOw=="


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Light.eot
// module id = 98
// module chunks = 0